import { render, staticRenderFns } from "./permission.vue?vue&type=template&id=317a509e&"
import script from "./permission.vue?vue&type=script&lang=ts&"
export * from "./permission.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports